/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Trigger_TypeInputs */

const cs_automation_trigger_type = /** @type {(inputs: Automation_Trigger_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ triggeru`)
};

const en_automation_trigger_type = /** @type {(inputs: Automation_Trigger_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger type`)
};

/**
* | output |
* | --- |
* | "Trigger type" |
*
* @param {Automation_Trigger_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_type = /** @type {((inputs?: Automation_Trigger_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_type(inputs)
	return cs_automation_trigger_type(inputs)
});